
import { mapActions, mapState, mapGetters } from "vuex";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
export default {
  components: { ConfirmationDialog, BrandAvatarWithColor },
  props: {
    channel: {
      type: Object,
      default: () => {}
    },
    brand: {
      type: Object,
      default: () => {}
    },
    showBrandInfo: {
      type: Boolean,
      default: false
    },
    showChannelLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showStoreConfirmationDialog: false,
      onlineSwitch: false,
      isIntegrationOngoing: false
    };
  },

  computed: {
    ...mapState("reciever", ["recieverSettings"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["getRestaurantDetailedInfo"]),
    getChannel() {
      return (
        this.getRestaurantDetailedInfo(this.brand.id).restaurant_platforms.find(
          (el) =>
            el.platform_name ===
            (this.channel.platform_name || this.channel.name)
        ) || {}
      );
    }
  },
  watch: {
    locationDetails() {
      this.$nextTick(() => {
        this.initStatus();
      });
    }
  },
  mounted() {
    this.initStatus();
  },
  methods: {
    ...mapActions("reciever", ["patchChannelState"]),
    initStatus() {
      if (this.getChannel.state === "online") {
        this.onlineSwitch = true;
      } else if (this.getChannel.state === "integration_ongoing") {
        this.isIntegrationOngoing = true;
      } else {
        this.onlineSwitch = false;
      }
    },
    switchChange(val) {
      this.loading = true;
      this.patchChannelState({
        restaurantId: this.brand.id,
        id: this.getChannel.id,
        payload: { new_state: val ? "online" : "offline" }
      })
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response?.data?.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.onlineSwitch = !val;
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSwitchToggle(val) {
      // if (this.showBrandInfo) {
      //   if (!val) {
      //     this.$nuxt.$emit("show-info-dialog", {
      //       content:
      //         "Please note that you won't receive any orders when you are on offline mode."
      //     });
      //     this.$emit("close-dialog");
      //   }
      // } else {
      //   this.$vuetify.breakpoint.smAndDown
      //     ? this.handleOfflineDialog(val)
      //     : this.switchChange(val);
      // }
      this.switchChange(val);
    },
    handleOfflineDialog(val) {
      if (!val) {
        this.showStoreConfirmationDialog = true;
      } else {
        this.switchChange(val);
      }
    },
    switchOfflineMobile() {
      this.switchChange(this.onlineSwitch);
      this.showStoreConfirmationDialog = false;
    },
    handleOfflineCancellation() {
      this.onlineSwitch = true;
      this.showStoreConfirmationDialog = false;
    }
  }
};
